import { useToggleState } from '@cian/react-utils';
import { Image, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IRosreestrPlanProps {
  /** Расширенное превью для кадастровой карты 1000x1000 **/
  fullUrl?: string | null;
  /** Превью для кадастровой карты 512x512 **/
  previewUrl: string;
  onPreviewClick(): void;
}

export const RosreestrPlan = ({ fullUrl, previewUrl, onPreviewClick }: IRosreestrPlanProps) => {
  const { state, toggle } = useToggleState(false);

  const handlePreviewClick = React.useCallback(() => {
    toggle();
    onPreviewClick();
  }, [onPreviewClick, toggle]);

  return (
    <>
      <div className={styles['plan']} role="button" onClick={handlePreviewClick}>
        <div className={styles['image']}>
          <Image display="inline-block" src={previewUrl} objectFit="cover" alt="Превью плана участка" />
        </div>
        <div className={styles['overlay']} />
      </div>
      <ModalWindow
        title="План участка"
        open={state}
        onClose={toggle}
        content={<Image src={fullUrl || previewUrl} alt="Изображение плана участка" height={580} width={580} />}
      />
    </>
  );
};
